const Slider = async (productsContainer) => {
  let autoplaySpeed = productsContainer.getAttribute("data-autoplay-speed");
  let layout = productsContainer.getAttribute("data-layout");
  let slidesToView = productsContainer.getAttribute("data-slides-per-view") || 4;
  let slidesToView_768 = 2;
  let slideCenter = false;
  let isDynamicBullets = productsContainer.getAttribute("data-dynamic-pagination");
  isDynamicBullets = isDynamicBullets === "true";
  if (layout === "big-image" || layout === "big-product") {
    slidesToView_768 = 1;
  } else if (layout === "base") {
    slidesToView_768 = 1.4;
    slideCenter = true;
  }
  const Swiper = window.themeCore.utils.Swiper;
  const Autoplay = await window.themeCore.utils.getExternalUtil("swiperAutoplay");
  Swiper.use([Autoplay]);
  function init() {
    const productsSlider = new Swiper(productsContainer, {
      slidesPerView: 1,
      centeredSlides: slideCenter,
      loop: true,
      spaceBetween: 16,
      autoplay: autoplaySpeed ? {
        delay: autoplaySpeed
      } : false,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        bulletElement: "button",
        clickable: true,
        dynamicBullets: isDynamicBullets
      },
      breakpoints: {
        768: {
          slidesPerView: slidesToView_768
        },
        1200: {
          slidesPerView: slidesToView
        }
      }
    });
    productsSlider.update();
  }
  return Object.freeze({
    init
  });
};
const selectors = {
  products: ".js-custom-product-content-slider"
};
const CustomProducts = () => {
  async function init(sectionId) {
    const productsContainers = [
      ...document.querySelectorAll(selectors.products)
    ].filter((section) => !sectionId || section.closest(`#shopify-section-${sectionId}`));
    productsContainers.forEach(async (productsContainer) => {
      const slider = await Slider(productsContainer);
      slider.init();
    });
  }
  return Object.freeze({
    init
  });
};
const action = () => {
  window.themeCore.CustomProducts = window.themeCore.CustomProducts || CustomProducts();
  window.themeCore.utils.register(window.themeCore.CustomProducts, "custom-products");
};
if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
